import { Box, Grid, IconButton, Link, Typography } from "@material-ui/core";
import DownloadIcon from "@material-ui/icons/GetApp";
import { ApplicationClientDto, ApplicationClientRoles } from "../../../api/apiClients";
import { getClientDisplayName } from "../../../common/helpers";
import { SubtitleText } from "../../controls/helpers";
import { ApplicantRoleChip } from "../IconsAndChips";
import { Details, Section } from "../Section";

const AmlCheck = ({ client, isKsOnly }: { client: ApplicationClientDto; isKsOnly: boolean }) => {
  return client.applicationCompleted ? (
    <Grid item xs={12}>
      <Section hideTopBorder hideBottomBorder>
        <Details>
          <SubtitleText black hideMarginBottom>
            <b>{getClientDisplayName(client)}</b>
          </SubtitleText>
          <Box flexGrow={1} textAlign="right">
            <ApplicantRoleChip title={client.role === ApplicationClientRoles.Primary ? "Primary" : "Secondary"} />
          </Box>
        </Details>
      </Section>
      <Section hideBottomBorder>
        <Details title="Geolocation">
          <Typography variant="subtitle1">
            <b>{client.ipFailed === undefined ? "N/A" : client.ipFailed ? "With Compliance for review" : "Pass"}</b>
          </Typography>
        </Details>
      </Section>
      <Section hideBottomBorder>
        <Details title="Identity verification">
          <Typography variant="subtitle1">
            <b>{client.cloudCheckFailed === undefined ? "N/A" : client.cloudCheckFailed ? "Documentary verification required" : "Pass"}</b>
          </Typography>
        </Details>
      </Section>
      {!!client.cloudCheckFailed && (
        <Section hideTopBorder hideBottomBorder>
          <Details title="Download AML Form 1a">
            <Link href="https://www.nzfunds.co.nz/assets/docs/shared/NZF_AML01A_AML_for_an_Individual_March_2023.pdf" target="_blank">
              <IconButton size="small">
                <DownloadIcon />
              </IconButton>
            </Link>
          </Details>
        </Section>
      )}
      {!!client.hasLiveVerificationReference && (
        <Section hideBottomBorder>
          <Details title="Liveness">
            <Typography variant="subtitle1">
              <b>{client.livenessFailed === undefined ? "N/A" : client.livenessFailed ? "With Client Services for review" : "Pass"}</b>
            </Typography>
          </Details>
        </Section>
      )}
      {!isKsOnly && (
        <Section hideBottomBorder>
          <Details title="Non-compliant country">
            <Typography variant="subtitle1">
              <b>{client.nccFailed === undefined ? "N/A" : client.nccFailed ? "With Compliance for review" : "Pass"}</b>
            </Typography>
          </Details>
        </Section>
      )}
      <br />
    </Grid>
  ) : null;
};

export default AmlCheck;
